export const images = {
  engenharia: './assets/images/engenharia.webp',
  radiologia: './assets/images/radiologia.webp'
}
